import * as React from "react";

const NISArrowLeftIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12" fill="none">
            <path d="M0.329348 4.82959L4.82934 0.32959C5.26879 -0.109863 5.98071 -0.109863 6.42016 0.32959C6.85961 0.769043 6.85961 1.48096 6.42016 1.92041L3.84233 4.49912H16.8747C17.4966 4.49912 17.9997 5.00221 17.9997 5.62412C17.9997 6.24604 17.4966 6.74912 16.8747 6.74912H3.84233L6.42209 9.32889C6.86154 9.76834 6.86154 10.4803 6.42209 10.9197C5.98299 11.3588 5.27108 11.3595 4.83127 10.9197L0.331282 6.41971C-0.110104 5.9792 -0.110104 5.26904 0.329348 4.82959Z" fill="#2B5197" />
        </svg>
    );
};

export default React.memo(NISArrowLeftIcon);
